<template>
  <div class="loginVerification">
    <div class="top-bg">
      <img src="@/assets/images/home/login-verification-bg.png" alt="">
    </div>
    <!-- 内容区域 -->
    <div class="content">
      <div class="title">温馨提示</div>
      <div class="message">
        {{ messageContent }}
      </div>

      <img src="@/assets/images/person/memberType0.png" alt="" class="tip-img" v-if="userInfo.memberType == 0">
      <img src="@/assets/images/person/memberType1.png" alt="" class="tip-img" v-else>

      <!-- 按钮区域 -->
      <div class="button-group">
        <van-button
          v-if="showModifyBtn"
          class="modify-btn"
          @click="handleModify"
          v-track="{ functionName: '身份识别-修改资料' }"
        >
          修改资料
        </van-button>
        <van-button
          class="appeal-btn"
          :class="!showAppealBtn ? 'disabled' :''"
          @click="handleAppeal"
          v-track="{ functionName: '身份识别-我要申诉' }"
        >
          我要申诉
        </van-button>
        <van-button
          v-if="showSkipBtn"
          class="skip-btn"
          @click="handleSkip"
          v-track="{ functionName: '身份识别-跳过' }"
        >
          跳过
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {getUserIdentity, veevaStatusFail} from '../../utils/util'
import withRouteTracking from '@/utils/withRouteTracking'
/**
 * 资料修改次数
 * private int updateNumber;
 * 员工状态
 * private String employeeStatus;
 * 0医生1员工
 * private Integer memberType;
 * 是否到了禁用期
 * private Boolean isDueDate;
 * 术者到期日
 * private String hcpDisableDate;
 * 员工到期日
 * private String employeeDisableDate;
 * 默认修改次数
 * private int defaultUpdateNumber;
 */
const Profile = {
  name: 'LoginVerification',
  data() {
    return {
      userIdentity: getUserIdentity(),
    }
  },
  computed: {
    isHcp() {
      return this.userInfo.memberType == 0
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
    /*
     * 如果是HCP且在状态为未发起认证或者认证失败一次时显示修改资料
     */
    showModifyBtn() {
      return this.isHcp && (this.userIdentity.updateNumber === 0 || this.userIdentity.updateNumber < this.userIdentity.defaultUpdateNumber)
    },
    /*
     * 正式禁用前, 显示
     */
    showSkipBtn() {
      const isDue = this.userIdentity.isDueDate
      // 如果到期了，直接返回false
      if (isDue) {
        return false
      }
      // 仅术者：员工没有 hcpDisableDate，不能按这个字段隐藏跳过
      if (this.isHcp && !this.hasHcpDisableDate) {
        return false
      }
      // 如果是没到期，检查更新次数和veeva状态
      if (this.userIdentity.updateNumber >= 1 && veevaStatusFail.includes(this.userIdentity.veevaStatus) && this.isHcp) {
        return false
      }
      return !isDue
    },
    // 术者禁用日期是否有效。null、空字符串、"null"、"undefined" 都视为没有日期
    hasHcpDisableDate() {
      const date = this.userIdentity && this.userIdentity.hcpDisableDate
      if (date == null) return false
      const text = String(date).trim()
      return !!text && text !== 'null' && text !== 'undefined'
    },
    showAppealBtn() {
      const loginResult = sessionStorage.getItem('iepLoginResult')
      if (!loginResult) return false
      const {userIdentity, isUserInfo} = JSON.parse(loginResult)
      // veevaStatus 为失败状态或为空/null/undefined 时，六字段缺失不显示申诉按钮
      const isVeevaInvalid = !userIdentity.veevaStatus || veevaStatusFail.includes(userIdentity.veevaStatus)
      if (isVeevaInvalid && isUserInfo === 0 && this.isHcp) {
        return false
      }
      return this.userIdentity.appealStatus === null || this.userIdentity.appealStatus === undefined
    },
    // 根据用户类型和状态显示对应消息
    messageContent() {
      if (this.isHcp) {
        return this.getHcpMessage()
      } else {
        return this.getEmployeeMessage()
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 获取HCP相关消息
    getHcpMessage() {
      if (!this.userIdentity.isDueDate) {
        if (this.userIdentity.updateNumber === 0) {
          if (!this.hasHcpDisableDate) {
            return `尊敬的用户, 您好：
            根据最新的iEP平台用户协议，平台目前仅对已认证的医生进行开放。
            由于您的账号未认证成功，平台已自动关闭您的权限。
            为了不影响您的正常使用，请尽快进入iEP平台完成身份重新认证。
            如果您认为身份识别有误，可以在平台内提交申诉申请或联系强生员工，我们会尽快为您核实。`
          }
          return `尊敬的用户, 您好：
            根据最新的iEP平台用户协议，平台目前仅对已认证的医生进行开放。
            由于您的账号被识别为未认证身份，为了不影响您的正常使用，请在 ${this.userIdentity.hcpDisableDate} 前尽快进入iEP平台完成身份重新认证。
            如果您认为身份识别有误，可以在平台内提交申诉申请，我们会尽快为您核实。`
        }
        if (this.userIdentity.updateNumber < this.userIdentity.defaultUpdateNumber) {
          return `尊敬的用户, 您好：
            您的医生身份认证未成功，您可尝试再次进行【修改资料】（剩余${this.userIdentity.defaultUpdateNumber - this.userIdentity.updateNumber}次修改机会），进行认证。`
        }
        if (this.userIdentity.updateNumber === this.userIdentity.defaultUpdateNumber) {
          return `尊敬的用户, 您好：
            您的医生身份${this.userIdentity.defaultUpdateNumber}次认证仍未成功，如果您认为身份识别有误，可以在平台内提交申诉申请或联系强生员工，我们会尽快为您核实。`
        }
      } else {
        if (this.userIdentity.updateNumber === 0) {
          return `尊敬的用户, 您好：
            根据最新的iEP平台用户协议，平台目前仅对已认证的医生进行开放。
            由于您的账号未认证成功，平台已自动关闭您的权限。
            为了不影响您的正常使用，请尽快进入iEP平台完成身份重新认证。
            如果您认为身份识别有误，可以在平台内提交申诉申请或联系强生员工，我们会尽快为您核实。`
        }
        if (this.userIdentity.updateNumber < this.userIdentity.defaultUpdateNumber) {
          return `尊敬的用户, 您好：
            您的医生身份认证未成功，您可尝试再次进行【修改资料】（剩余${this.userIdentity.defaultUpdateNumber - this.userIdentity.updateNumber}次修改机会），进行认证。`
        }
        if (this.userIdentity.updateNumber === this.userIdentity.defaultUpdateNumber) {
          return `尊敬的用户, 您好：
            您的医生身份${this.userIdentity.defaultUpdateNumber}次认证仍未成功，如果您认为身份识别有误，可以在平台内提交申诉申请或联系强生员工，我们会尽快为您核实。`
        }
      }
    },

    // 获取员工相关消息
    getEmployeeMessage() {
      if (this.userIdentity.isDueDate) {
        return `尊敬的用户, 您好：
        您已被识别为离职员工，平台已自动关闭您的权限。
        如果您认为身份识别有误，可以在平台内提交申诉申请，帮助我们核实您的身份。
        感谢您的理解与配合！`
      } else {
        return `尊敬的用户, 您好：
        您已被识别为离职员工，平台将在 ${this.userIdentity.employeeDisableDate} 自动关闭您的权限。
        如果您认为身份识别有误，可以在平台内提交申诉申请，帮助我们核实您的身份。
        感谢您的理解与配合！`
      }
    },

    // 修改资料
    handleModify() {
      if (this.userInfo.memberType != 0) {
        this.$toast('医生身份才能修改资料')
        return
      }
      localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/register`)
      this.$router.push({
        path: '/register',
        query: {
          isEidt: true,
          from: 'loginVerification'
        }
      })
    },
    // 我要申诉
    async handleAppeal() {
      const loginResult = sessionStorage.getItem('iepLoginResult')
      if (!loginResult) return false
      const {userIdentity, isUserInfo, uuid, appid} = JSON.parse(loginResult)
      // veevaStatus 为失败状态或为空/null/undefined 时，六字段缺失不允许申诉
      const isVeevaInvalid = !userIdentity.veevaStatus || veevaStatusFail.includes(userIdentity.veevaStatus)
      if (isVeevaInvalid && isUserInfo === 0 && this.isHcp) {
        this.$toast('基础信息待补全的用户仅支持【修改资料】哦，谢谢配合。')
        return
      }
      // 如果是员工就跳我们申诉页，不是就跳ciam
      if (this.userInfo.memberType == 1) {
        if (!this.showAppealBtn) {
          this.$toast('您的申诉已提交')
          return
        }
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/appealPage`)
        this.$router.push('/appealPage')
        return
      }
      let url = `${process.env.ciamDomain}/customer/strong-auth-apply?uuid=${uuid}&appId=${appid}&returnUrl=${encodeURIComponent(`${process.env.baseURL}/loginVerification`)}`
      localStorage.setItem('functionUrl', url)
      console.log('appealUrl', url)
      window.location.href = url
    },
    // 跳过
    handleSkip() {
      let iepLoginResult = JSON.parse(sessionStorage.getItem('iepLoginResult'))
      iepLoginResult.userIdentity.isJudge = false
      sessionStorage.setItem('iepLoginResult', JSON.stringify(iepLoginResult))
      this.$router.replace('/home')
    }
  }
}
export default withRouteTracking(Profile)
</script>

<style scoped lang="less">
.loginVerification {
  position: relative;
  width: 100%;
  height: 100vh;
  padding: 48px 12px 0;
  box-sizing: border-box;

  .top-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;

    img {
      width: 100%;
    }
  }

  .content {
    position: relative;
    padding: 24px;
    background: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-size: 24px;
      font-weight: 600;
      color: #181818;
      text-align: center;
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translateX(-50%);
      font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
    }

    .message {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      margin-bottom: 20px;
      white-space: pre-line;
      line-height: 25px;
    }

    .tip-img {
      width: 160px;
    }
  }
}

.button-group {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 16px;
  width: 100%;
  padding: 0 24px;
}

.modify-btn {
  border-radius: 22px;
  font-size: 16px;
  font-weight: 500;
  width: 100%;
  height: 42px;
  background: #EB1700;
  font-family: PingFang SC, PingFang SC;
  color: #FFFFFF;
  cursor: pointer;
  border: none;
}

.appeal-btn {
  border-radius: 22px;
  font-size: 16px;
  font-weight: 500;
  width: 100%;
  height: 42px;
  border: 1px solid #EB1700;
  font-family: PingFang SC, PingFang SC;
  color: #EB1700;
  cursor: pointer;
  background: #fff;

  &.disabled {
    opacity: .5;
    cursor: not-allowed;
    color: #323233;
    background-color: #fff;
    border: 1px solid #ebedf0;
  }
}

.skip-btn {
  cursor: pointer;
  border: none;
  height: 21px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #7D7D7D;
  background: transparent;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/loginPage/loginVerification.vue